<template>
  <div class="container-form margin-top-30">
    <div class="row">
      <div class="col-md-12">
        <h4 class="section-name-form">{{companyName}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 margin-top-15">
        <form-input
          input-type="text"
          input-name="cui-disabled"
          :input-label="cuiLabel"
          :input-value="cui"
          :setInput="function(){}"
          :is-valid="true"
          :disabled="true"
        ></form-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 margin-top-15">
        <form-input
          input-type="text"
          input-name="register-num"
          :input-label="registerNumLabel"
          :input-value="registerNum"
          :setInput="setRegisterNum"
          :is-valid="validRegisterNum"
          :disabled="false"
          :error-text="registerNumInvalid"
        ></form-input>
      </div>
    </div>
    <div class="row margin-top-30">
      <div class="col-md-12">
        <h4 class="section-name-form">Adresa sediului</h4>
        <p class="section-description-form">Adresa va fi folosită pentru generarea contractului</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 margin-top-15">
        <form-input
          input-type="text"
          input-name="address"
          :input-label="addressLabel"
          :input-value="address"
          :setInput="function(){}"
          :is-valid="true"
          :disabled="true"
        ></form-input>
      </div>
    </div>
    <div class="row margin-top-30">
      <div class="col-md-12">
        <h4 class="section-name-form">Adresa de corespondență</h4>
        <p
          class="section-description-form"
        >Adresa de corespondență va fi folosită pentru livrarea contractelor semnate și ștampilate. Dacă adresa de corespondență este diferită debitează căsuța de mai jos și completează datele.</p>
        <form-checkbox
          input-name="same-address"
          :is-init-checked="isSameAddress"
          :input-label="checkboxLabel"
          :setInput="check"
        ></form-checkbox>
      </div>
    </div>
    <div v-if="!isSameAddress">
      <div class="row">
        <div class="col-md-12 margin-top-15">
          <form-input
            input-type="text"
            input-name="address-corresp"
            :input-label="addressLabel"
            :input-value="addressCorresp"
            :setInput="setAddressCorresp"
            :is-valid="validAddressCorresp"
            :disabled="false"
            :error-text="addressInvalid"
          ></form-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 margin-top-15">
          <form-selector
            :selectLabel="countyLabel"
            selectName="counties-list"
            :options="counties"
            :selectedOption="countyCorresp"
            :selectValue="setCountyCorresp"
            :error-text="countyInvalid"
            :isValid="validCountyCorresp"
          ></form-selector>
        </div>
        <div class="col-md-4 margin-top-15">
          <form-input
            input-type="text"
            input-name="city-corresp"
            :input-label="cityLabel"
            :input-value="cityCorresp"
            :setInput="setCityCorresp"
            :is-valid="validCityCorresp"
            :disabled="false"
            :error-text="cityInvalid"
          ></form-input>
        </div>
        <div class="col-md-4 margin-top-15">
          <form-input
            input-type="text"
            input-name="postal-code-corresp"
            :input-label="postalCodeLabel"
            :input-value="postalCodeCorresp"
            :setInput="setPostalCodeCorresp"
            :is-valid="validPostalCodeCorresp"
            :disabled="false"
            :error-text="postalCodeInvalid"
          ></form-input>
        </div>
      </div>
    </div>
    <div class="align-button-form margin-top-30">
      <button-form button-name="PASUL URMĂTOR" :on-click="nextStep"></button-form>
    </div>
  </div>
</template>

<script>
import FormInput from "../global/FormInput";
import FormCheckbox from "../global/FormCheckbox";
import FormSelector from "../global/FormSelector";
import ButtonForm from "../global/ButtonForm";
import { Counties } from "../../content/SelectLists";
import { mapMutations, mapState } from "vuex";
import { isNumber, notNull } from "../../helpers/Validations";

import {
  CUI_DETAILED_LABEL,
  REGISTER_NUM_LABEL,
  ADDRESS_LABEL,
  CHECKBOX_LABEL,
  CITY_LABEL,
  POSTAL_CODE_LABEL,
  COUNTY_LABEL
} from "../../content/FormLabels";

import {
  REGISTER_NUM_INVALID,
  ADDRESS_INVALID,
  POSTAL_CODE_INVALID,
  CITY_INVALID,
  COUNTY_INVALID
} from "../../content/FormErrors";

export default {
  components: {
    FormInput,
    FormCheckbox,
    FormSelector,
    ButtonForm
  },
  data() {
    return {
      cuiLabel: CUI_DETAILED_LABEL,
      registerNumLabel: REGISTER_NUM_LABEL,
      addressLabel: ADDRESS_LABEL,
      checkboxLabel: CHECKBOX_LABEL,
      postalCodeLabel: POSTAL_CODE_LABEL,
      cityLabel: CITY_LABEL,
      countyLabel: COUNTY_LABEL,
      counties: Counties,
      registerNumInvalid: REGISTER_NUM_INVALID,
      addressInvalid: ADDRESS_INVALID,
      postalCodeInvalid: POSTAL_CODE_INVALID,
      cityInvalid: CITY_INVALID,
      countyInvalid: COUNTY_INVALID
    };
  },
  computed: {
    ...mapState({
      isSameAddress: state => state.formInputs.isSameAddress,
      cui: state => state.formInputs.cui,
      companyName: state => state.formInputs.companyName,
      address: state => state.formInputs.address,
      registerNum: state => state.formInputs.registerNum,
      addressCorresp: state => state.formInputs.addressCorresp,
      postalCodeCorresp: state => state.formInputs.postalCodeCorresp,
      cityCorresp: state => state.formInputs.cityCorresp,
      countyCorresp: state => state.formInputs.countyCorresp,
      validRegisterNum: state => state.isFormValid.registerNum,
      validAddressCorresp: state => state.isFormValid.addressCorresp,
      validPostalCodeCorresp: state => state.isFormValid.postalCodeCorresp,
      validCityCorresp: state => state.isFormValid.cityCorresp,
      validCountyCorresp: state => state.isFormValid.countyCorresp
    })
  },
  methods: {
    ...mapMutations([
      "toggleIsSameAddress",
      "addRegisterNum",
      "addAddressCorresp",
      "addPostalCodeCorresp",
      "addCountyCorresp",
      "addCityCorresp",
      "isRegisterNumValid",
      "isAddressCorrespValid",
      "isPostalCodeCorrespValid",
      "isCityCorrespValid",
      "isCountyCorrespValid",
      "incrementWizardStep"
    ]),
    check: function() {
      this.toggleIsSameAddress();
    },
    setRegisterNum: function(event) {
      if (this.registerNum !== event.target.value.trim())
        this.addRegisterNum(event.target.value.trim());
    },
    setAddressCorresp: function(event) {
      if (this.addressCorresp !== event.target.value.trim())
        this.addAddressCorresp(event.target.value.trim());
    },
    setPostalCodeCorresp: function(event) {
      if (this.postalCodeCorresp !== event.target.value.trim())
        this.addPostalCodeCorresp(event.target.value.trim());
    },
    setCityCorresp: function(event) {
      if (this.cityCorresp !== event.target.value.trim())
        this.addCityCorresp(event.target.value.trim());
    },
    setCountyCorresp: function(value) {
      if (this.countyCorresp !== value) this.addCountyCorresp(value);
    },
    nextStep: function() {
      const isRegisterNumValid = notNull(this.registerNum);
      this.isRegisterNumValid(isRegisterNumValid);

      if (!isRegisterNumValid && this.isSameAddress) return;

      if (isRegisterNumValid && this.isSameAddress) {
        return this.incrementWizardStep();
      }

      const isAddressCorrespValid = notNull(this.addressCorresp);
      this.isAddressCorrespValid(isAddressCorrespValid);

      const isPostalCodeCorrespValid = isNumber(this.postalCodeCorresp);
      this.isPostalCodeCorrespValid(isPostalCodeCorrespValid);

      const isCityCorrespValid = notNull(this.cityCorresp);
      this.isCityCorrespValid(isCityCorrespValid);

      const isCountyCorrespValid = notNull(this.countyCorresp);
      this.isCountyCorrespValid(isCountyCorrespValid);

      if (
        isRegisterNumValid &&
        isAddressCorrespValid &&
        isPostalCodeCorrespValid &&
        isCityCorrespValid &&
        isCountyCorrespValid
      ) {
        this.incrementWizardStep();
      }
    }
  }
};
</script>
